import { useEffect, useState } from 'react';
import { getForYouMembership } from '../repositories/forYouRepository';
import {
  getSavedSearchPresence,
  setSavedSearchPresence,
  subscribeToSavedSearchPresence,
} from '../utils/savedSearchPresence';

/**
 * Whether the reader has any feeds, for the navbar's For You gate.
 *
 * Returns false until the answer is known, so the link appears rather than
 * disappears as the page settles -- a control that flickers out is worse than
 * one that arrives a beat late. Anonymous visitors never ask.
 */
export function useSavedSearchPresence(enabled: boolean): boolean {
  const [present, setPresent] = useState<boolean | null>(getSavedSearchPresence);

  useEffect(() => subscribeToSavedSearchPresence(setPresent), []);

  useEffect(() => {
    if (!enabled || present !== null) return;
    let cancelled = false;
    getForYouMembership()
      .then((membership) => {
        if (!cancelled) setSavedSearchPresence(membership.saved_search_count > 0);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [enabled, present]);

  // `enabled` gates the answer, not just the request: the store outlives a
  // sign-out within the same page session, and a stale `true` must not draw a
  // link into an anonymous visitor's navbar.
  return enabled && present === true;
}
